import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class BackUrlResolver  {

  resolve(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): string {
    return state.url;
  }
}
